import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';

/**
 * Bouton de retour réutilisable
 * @param {string} to - Route vers laquelle naviguer (optionnel, utilise history.back() par défaut)
 * @param {string} label - Texte du bouton (optionnel)
 * @param {string} className - Classes CSS supplémentaires
 */
export default function BackButton({ to, label, className }) {
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        "inline-flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-medium transition-all duration-200",
        isDark 
          ? "text-white/60 hover:text-white hover:bg-white/[0.06]" 
          : "text-gray-500 hover:text-gray-900 hover:bg-gray-100",
        className
      )}
      data-testid="back-button"
    >
      <ArrowLeft size={18} weight="bold" />
      {label || 'Retour'}
    </button>
  );
}
